<template>
  <div>
    <!-- ZOHO -->
    <template v-if="zoho">
      <div class="pt-x1 pb-x1" v-if="includeName">
        <div class="avatar-with-name" v-for="(creative, index) in creativesArray" :key="index">
          <div class="user-name full-name">{{ creative }}</div>
        </div>
      </div>
      <div class="pt-x1 pb-x1" v-else-if="filter">
        <button class="avatar-with-name zero-btn" v-for="(creative, index) in creativesArray" :key="index" @click="$emit('filterEmit', creative)" :class="{ 'selected' : activeFilters.includes(creative) }">
          <div class="user-name full-name">{{ creative }}</div>
        </button>
        <!--  on parent, attach @filterEmit="yourMethod" to component reference, no parentheses on method call => will auto send variable to that method for processing -->
      </div>
      <div class="pt-x1 pb-x1" v-else>
        <div class="avatar-with-name" v-for="(creative, index) in creativesArray" :key="index">
          <div class="user-name full-name">{{ creative }}</div>
        </div>
      </div>
    </template>
    <!-- NON ZOHO -->
    <template v-else>
      <div class="pt-x1 pb-x1" v-if="includeName">
        <div class="avatar-with-name" v-for="(creative, index) in creativesArray" :key="index">
          <div class="avatar-image sm avatar-background" :style="[ creative.userimage ? { backgroundImage: 'url(' + filePath + 'uploads/profiles/' + creative.userimage + ')' } : {}]">
            <span v-if="!creative.userimage">{{ creative.name[0] }}</span>
          </div>
          <div class="user-name">{{ creative.name.split(' ')[0] }}</div>
        </div>
      </div>
      <div class="pt-x1 pb-x1" v-else-if="filter">
        <button class="avatar-with-name zero-btn" v-for="(creative, index) in creativesArray" :key="index" @click="$emit('filterEmit', creative.email)" :class="{ 'selected' : activeFilters.includes(creative.email) }">
          <div class="avatar-image sm avatar-background" :style="[ creative.userimage ? { backgroundImage: 'url(' + filePath + 'uploads/profiles/' + creative.userimage + ')' } : {}]">
            <span v-if="!creative.userimage">{{ creative.name[0] }}</span>
          </div>
          <div class="user-name">{{ creative.name.split(' ')[0] }}</div>
        </button>
        <!--  on parent, attach @filterEmit="yourMethod" to component reference, no parentheses on method call => will auto send variable to that method for processing -->
      </div>
      <div class="pt-x1 pb-x1" v-else-if="picker">
        <div class="d-inline-block" v-for="(user, index) in allUsers" :key="index">
          <button v-if="creativesArray.includes(user.email)" class="avatar-with-name zero-btn selected" @click="removeCreative(user.email)">
            <div class="avatar-image sm avatar-background" :style="[ user.userimage ? { backgroundImage: 'url(' + filePath + 'uploads/profiles/' + user.userimage + ')' } : {}]">
              <span v-if="!user.userimage">{{ user.name[0] }}</span>
            </div>
            <div class="user-name">{{ user.name.split(' ')[0] }}</div>
          </button>
          <button v-else class="avatar-with-name zero-btn" @click="addCreative(user.email)">
            <div class="avatar-image sm avatar-background" :style="[ user.userimage ? { backgroundImage: 'url(' + filePath + 'uploads/profiles/' + user.userimage + ')' } : {}]">
              <span v-if="!user.userimage">{{ user.name[0] }}</span>
            </div>
            <div class="user-name">{{ user.name.split(' ')[0] }}</div>
          </button>
        </div>
      </div>
      <div class="pt-x1 pb-x1" v-else>
        <div class="avatar-stack-item" v-for="(creative, index) in creativesArray" :key="index">
          <div class="avatar-image lg avatar-background" :style="[ creative.userimage ? { backgroundImage: 'url(' + filePath + 'uploads/profiles/' + creative.userimage + ')' } : {}]" :title="creative.name">
            <span v-if="!creative.userimage">{{ creative.name[0] }}</span>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
// endpoints
const apiChoice = process.env.VUE_APP_API_URL

export default {
  name: 'CreativesList',
  props: {
    creatives: {
      type: String,
      default: ''
    },
    allUsers: {
      type: Array,
      default: () => []
    },
    includeName: {
      type: Boolean,
      default: false
    },
    filter: {
      type: Boolean,
      default: false
    },
    picker: {
      type: Boolean,
      default: false
    },
    activeFilters: {
      type: Array,
      default: () => []
    },
    zoho: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    creatives: function () {
      if (!this.zoho) {
        this.setCreativesArray()
      } else {
        this.emailOnly()
      }
    },
    activeFilters: function () {
      this.setActiveFilters()
    }
  },
  data () {
    return {
      isLoggedIn: false,
      creativesArray: [],
      filtersArray: [],
      filePath: apiChoice,
      emptyUser: {
        'email': '',
        'name': '',
        'userimage': ''
      }
    }
  },
  components: {},
  created () {
    if (!this.zoho) {
      this.setCreativesArray()
    } else {
      this.emailOnly()
    }
  },
  mounted () {},
  computed: {},
  methods: {
    goHome () {
      this.$router.push({ path: '/' })
    },
    removeCreative (removeEmail) {
      this.creativesArray = this.creativesArray.filter((userEmail) => userEmail !== removeEmail)
      this.$emit('selectedCreatives', this.creativesArray.toString())
    },
    addCreative (addEmail) {
      this.creativesArray.push(addEmail)
      this.$emit('selectedCreatives', this.creativesArray.toString())
    },
    setCreativesArray () {
      if (this.picker) {
        // check if creatives is empty string to prevent split making empty item in array
        // picker uses all users so we don't need to map
        if (this.creatives) {
          this.creativesArray = this.creatives.replace(/\s+/g, '').split(',')
        } else {
          this.creativesArray = []
        }
      } else {
        if (this.creatives) {
          this.creativesArray = this.creatives.replace(/\s+/g, '').split(',').map((email) => (this.allUsers.find((user) => user.email === email)) ? this.allUsers.find((user) => user.email === email) : this.emptyUser)
        } else {
          this.creativesArray = []
        }
      }
    },
    setActiveFilters () {
      this.filtersArray = this.activeFilters
    },
    emailOnly () {
      this.creativesArray = this.creatives ? this.creatives.split(',') : []
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.user-image{
  border-radius: 50%;
  height: 28px;
}
.avatar-stack-item{
  display:inline-block;
  margin-left: -8px;
  padding: 0;
  &:first-child{
    margin-left:0px;
  }
  .avatar-image {
    box-shadow: 0px 0px 4px 1px rgba(0, 0, 0, 0.2);
  }
}
.avatar-with-name{
  display: inline-flex;
  align-items: center;
  vertical-align: top;
  margin-right: 4px;
  margin-bottom: 4px;
  border-radius: 80px;
  border: 1px solid #525f6b;
  padding: 4px;
  background: #fff;
  color: #342F30;
  .user-name{
    padding: 0px 8px;
    font-size: 14px;
    &.full-name{
      text-transform: capitalize;
    }
  }
  &.selected{
    background: #525f6b;
    color: #fff;
  }
}
// Media Queries
// Small devices (landscape phones, 576px and up)
@media (min-width: 576px) {
  .nav-menu-button{
    .avatar-greeting{
      display: block;
    }
    .avatar-chevron{
      display: none;
    }
  }
  .nav-logo {
    &.nav-logo-mobile {
      display: none;
    }
    &.nav-logo-desktop {
      display: block;
    }
  }
}
// Medium devices (tablets, 768px and up)
@media (min-width: 768px) {
}
// Large devices (desktops, 992px and up)
@media (min-width: 992px) {
}
// Extra large devices (large desktops, 1200px and up)
@media (min-width: 1200px) {
}
</style>
